import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {
  getPotContactId,
  updateRecsVarsProps,
  upsertBuilderHeader,
  validateMutationResponse,
} from './builderHelpers';
import validateUUID from '../../../utils/validateUUID';

export const saveAdHocFee = async (props: updateRecsVarsProps): Promise<string> => {
  const {accountId, sourcePots, values} = props;
  const {adHocFee, contact} = values;

  const ovrecommendId = await upsertBuilderHeader(props, {
    action: OVRecommendActionEnum.AD_HOC_FEE,
    accountId: validateUUID(accountId),
    contactId: getPotContactId(contact),
  });

  let potId = adHocFee?.planId;
  const pot = sourcePots
    ? sourcePots
        .flatMap((parent) => [parent, ...(parent.dentistChildren ?? [])]) // combine parents and children
        .find((x) => x.id === potId)
    : null;
  if (pot?.parent?.id) {
    potId = pot.parent.id;
  }

  const result = await props.upsertBuilderChargeAdHocFee({
    variables: {
      ovrecommendId: validateUUID(ovrecommendId)!,
      potId: validateUUID(potId)!,
      adhocFeeAmount:
        adHocFee?.feeType === 'GBP'
          ? adHocFee.monetaryFee!
          : adHocFee?.percentFee ?? undefined,
      adhocFeeType: adHocFee!.feeType!,
      adhocFeeReason: adHocFee!.reason!,
    },
  });
  validateMutationResponse(
    result.data?.upsertChargeAdHocFee,
    'Failed to save ad-hoc fee'
  );

  return ovrecommendId;
};
